import React from 'react';
import { observer } from 'mobx-react';
import { observable, computed } from 'mobx';
import DatePicker, { registerLocale } from 'react-datepicker';
import { de } from 'date-fns/locale';
import { Api } from '@seedlang/stores';
import pluralize from 'pluralize';
import { isPresent } from '@seedlang/utils';
import styled from '@emotion/styled';
import withLegend from 'components/form/with_legend';

const Label = styled.label`

`;

const PickerWrapper = styled.div`
  .react-datepicker__input-container input {
    width: 70px;
    min-width: 70px;
    max-width: 70px;
  }
`;

const LOCALE_24H = 'de';
if (typeof window !== 'undefined') {
  registerLocale(LOCALE_24H, de);
}

function getLocaleTimeConfig() {
  try {
    const formatter = new Intl.DateTimeFormat(undefined, { hour: 'numeric', minute: '2-digit' });
    const { hour12 } = formatter.resolvedOptions();
    return {
      format: hour12 === false ? 'HH:mm' : 'h:mm aa',
      locale: hour12 === false ? LOCALE_24H : undefined,
    };
  } catch {
    return { format: 'h:mm aa', locale: undefined };
  }
}

@observer
class InPlaceTimePicker extends React.Component {
  @observable selectedTime;

  static defaultProps = {
    isClearable: false,
    timeIntervals: 60,
  };

  @computed get value() {
    if (isPresent(this.selectedTime)) {
      return this.selectedTime;
    }
    if (isPresent(this.props.value) && this.props.value !== '') {
      const hour = parseInt(this.props.value, 10);
      if (!isNaN(hour) && hour >= 0 && hour <= 23) {
        return new Date(2000, 0, 1, hour, 0, 0);
      }
    }
    return null;
  }

  onChange = (date) => {
    const hour = date ? date.getHours() : null;
    this.selectedTime = date;
    if (this.props.onChange) {
      this.props.onChange(hour);
    } else if (this.props.onSubmit) {
      this.props.onSubmit(hour, this.props.field);
    } else {
      const data = {};
      data.data = {};
      data.data[this.props.field] = hour;
      Api.put({
        url: `/api/${pluralize(this.props.model)}/${this.props.id}`,
        data: { data },
        successCallback: this.updateSuccess.bind(this),
      });
    }
  }

  updateSuccess = (resp) => {
    if (this.props.updateCallback) {
      this.props.updateCallback(resp);
    }
    if (this.props.afterChange) {
      this.props.afterChange(this.value ? this.value.getHours() : null);
    }
  }

  render() {
    const { format, locale } = getLocaleTimeConfig();
    return (
      <PickerWrapper className='in-place-time-picker'>
        {
          this.props.label &&
            <Label>
              {this.props.label}
            </Label>
        }
        <DatePicker
          selected={this.value}
          onChange={this.onChange}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={this.props.timeIntervals}
          dateFormat={format}
          timeFormat={format}
          locale={locale}
          timeCaption='Time'
          isClearable={this.props.isClearable}
          popperPlacement={this.props.pickerPosition || 'bottom-end'}
        />
      </PickerWrapper>
    );
  }
}

export default withLegend(InPlaceTimePicker);
